import type { CmsZone } from "@/features/shop/cms/types/cms.types";

export const extractZoneByCode = (
  zones: CmsZone[],
  code: string,
): CmsZone | undefined => {
  return zones.find((zone) => zone.code === code);
};
